import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useESTList(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getESTList() {
    return privateFetch.get(`/v1/admin/est${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['est-lists', { data }], getESTList, { enabled, keepPreviousData: true });
}

export default useESTList;
